<script setup lang="ts"></script>

<template>
  <button
    class="flex items-center justify-center focus:z-10 pl-0.5 w-8 h-8 cursor-pointer hover:bg-slate-300 hover:border-slate-500 text-slate-500 bg-slate-200 focus:outline-none focus:ring-2 ring-offset-2 ring-offset-slate-500 ring-slate-200"
    type="button"
  >
    <slot />
  </button>
</template>
